let lastId = 0;
export function makeFilterId() {
  lastId += 1;
  return lastId;
}
